import { Column } from 'app/design/primitives/box';

export function LoanItemSeparator() {
  return <Column marginTop="spacing.general.x5" />;
}
